exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_description__2nM_J{color:#666;font-size:.8125rem;font-weight:300;line-height:1rem}.style_description__2nM_J p{margin:.5rem 0;font-size:.8125rem;color:#666}", ""]);

// exports
exports.locals = {
	"description": "style_description__2nM_J"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/MarkdownDescription/style.less
// module id = 1820
// module chunks = 8